export function notNil<T>(a: T | undefined | null): a is T {
	return a != null;
}
